{
  "seo": {
    "title": "Lean-консалтинг — порядок в процессах и рост EBITDA за 90 дней",
    "description": "Навожу порядок в производственных процессах: от хаоса до роста EBITDA за 90 дней. Нахожу скрытые потери без внедрения дорогого софта. Lean, А3-мышление, эмпатия. Бесплатный аудит процессов.",
    "keywords": "lean консалтинг, операционная эффективность, рост EBITDA, оптимизация производства, бережливое производство, А3 анализ, устранение потерь",
    "canonicalPath": "/lean"
  },
  "hero": {
    "badge": "Операционная эффективность",
    "title": "Навожу порядок в процессах: **от хаоса на производстве** до роста EBITDA за 90 дней",
    "lead": "Я нахожу скрытые потери там, где цифра встречается с ручным трудом. Без внедрения дорогого софта. Только Lean, А3-мышление и эмпатия.",
    "primaryCta": {
      "label": "Обсудить бардак на производстве",
      "href": "#contact"
    },
    "secondaryCta": {
      "label": "Хочу системный рост",
      "href": "#pricing"
    },
    "image": "https://readdy.ai/api/search-image?query=futuristic%20minimalist%203D%20composition%20left%20side%20chaotic%20scattered%20semi-transparent%20cubes%20and%20documents%20representing%20industrial%20chaos%20right%20side%20same%20composition%20transforming%20into%20glowing%20golden%20value%20stream%20chain%20orange%20accent%20dot%20at%20junction%20clean%20white%20background%20soft%20lighting%20high%20quality%20render&width=1200&height=900&seq=leanhero001&orientation=landscape",
    "imageAlt": "От хаоса к порядку",
    "imageAspect": "4/3",
    "imageCaption": ""
  },
  "pains": {
    "badge": "Точка боли",
    "title": "Почему аналитика и Process Mining **не дают результат?**",
    "subtitle": "Пять симптомов, которые чаще всего приносят ко мне на аудит",
    "items": [
      {
        "icon": "ri-file-text-line",
        "text": "У меня сотни процессов, но регламенты написаны для галочки."
      },
      {
        "icon": "ri-dashboard-line",
        "text": "Мы внедрили мониторинг, но операторы саботируют систему."
      },
      {
        "icon": "ri-time-line",
        "text": "Заказов море, а производство не вывозит и срывает сроки."
      },
      {
        "icon": "ri-wallet-3-line",
        "text": "Себестоимость растёт, а я не понимаю, куда утекают деньги."
      },
      {
        "icon": "ri-team-line",
        "text": "Персонал выгорает, текучка зашкаливает, обучение не работает."
      }
    ]
  },
  "vision": {
    "badge": "Суперсила",
    "title": "Я вижу финансовые потери **там, где вы видите рутину**",
    "subtitle": "Основа ваших убытков — это «стыки». Место, где оцифрованный план превращается в реальные действия рабочего.",
    "labels": {
      "digital": "Цифра",
      "human": "Человек",
      "crackButton": "Показать потери",
      "lossesTitle": "Четыре вида потерь, которые видны только на стыке",
      "operator": "Оператор"
    },
    "losses": [
      {
        "id": "defect",
        "label": "Брак и переделка",
        "desc": "Повторная работа из-за ошибок на линии",
        "icon": "ri-error-warning-line"
      },
      {
        "id": "overprocess",
        "label": "Излишняя обработка",
        "desc": "Лишние операции, которые не добавляют ценности",
        "icon": "ri-scissors-cut-line"
      },
      {
        "id": "inventory",
        "label": "Запасы и неликвиды",
        "desc": "Замороженные деньги в складах и полуфабрикатах",
        "icon": "ri-archive-line"
      },
      {
        "id": "motion",
        "label": "Перемещения и ожидания",
        "desc": "Лишние шаги и простои между операциями",
        "icon": "ri-walk-line"
      }
    ]
  },
  "methodology": {
    "badge": "Методология",
    "title": "3 недели до **дорожной карты изменений**",
    "subtitle": "Я не переписываю ваши регламенты. Я собираю данные с нуля, находясь рядом с исполнителями.",
    "steps": [
      {
        "num": "01",
        "title": "Иду в цех, общаюсь, шучу",
        "desc": "Сбор живых данных. Не из отчётов — из разговоров с операторами, мастерами и руководителями смен.",
        "icon": "ri-team-line"
      },
      {
        "num": "02",
        "title": "Карточка рабочего дня",
        "desc": "Yamazumi — вижу ритм оператора. Каждое движение, пауза и лишний шаг фиксируется в реальном времени.",
        "icon": "ri-time-line"
      },
      {
        "num": "03",
        "title": "Сборка А3-отчёта",
        "desc": "От проблемы к корневой причине. Без «костылей» и поверхностных решений — только структурированный анализ.",
        "icon": "ri-draft-line"
      },
      {
        "num": "04",
        "title": "Дорожная карта с финансовым весом",
        "desc": "Каждая задача — в деньгах. Приоритизация по EBITDA-impact, не по «хотелкам» руководства.",
        "icon": "ri-route-line"
      }
    ]
  },
  "pricing": {
    "badge": "Два пути",
    "title": "Выберите свой **формат**",
    "subtitle": "Оба сценария начинаются с бесплатной диагностики",
    "labels": {
      "situation": "Ситуация",
      "input": "Мой вход",
      "result": "Результат"
    },
    "plans": [
      {
        "badge": "Тушим пожар",
        "title": "Production спасает утопающих",
        "situation": "Заказов много, ничего не успеваем, полный хаос.",
        "input": "Мгновенная диагностика «узких горлышек», остановка потерь.",
        "result": "Быстрое высвобождение ресурсов, снижение переработок.",
        "cta": "Заказать экспресс-аудит",
        "accent": "orange"
      },
      {
        "badge": "Строим систему",
        "title": "От заявки до отгрузки",
        "situation": "Хотим масштабироваться, снизить ФОТ, повысить маржу.",
        "input": "Построение VSA, SIPOC, глубокий А3-анализ.",
        "result": "Прозрачная цепочка, понятный план роста, снижение себестоимости.",
        "cta": "Обсудить стратегию",
        "accent": "stone"
      }
    ]
  },
  "philosophy": {
    "badge": "Философия",
    "title": "Технологии и ИИ — **финальная прямая**, а не старт",
    "paragraphs": [
      "Пока на рабочих местах есть живые люди, 100% правды о процессах хранится только у них. Роботизация и ИИ — это крутой скачок, но только если технологии ложатся на живую культуру, эмпатию и правильные процессы.",
      "Сначала мы наводим порядок, вычисляем потери и настраиваем потоки. И только потом я даю рекомендации по цифровым решениям, которые приживутся и облегчат жизнь людям, а не создадут «автоматизированный хаос»."
    ],
    "tags": [
      "Lean",
      "A3-мышление",
      "VSA",
      "SIPOC",
      "Yamazumi",
      "Kaizen"
    ]
  },
  "contact": {
    "badge": "Бесплатная диагностика",
    "title": "Давайте разберём ваш **процесс**",
    "text": "Оставьте заявку — проведём бесплатный экспресс-аудит вашего производства и покажем, где вы теряете деньги прямо сейчас.",
    "bullets": [
      {
        "icon": "ri-time-line",
        "text": "Ответим в течение 15 минут"
      },
      {
        "icon": "ri-shield-check-line",
        "text": "Гарантия конфиденциальности"
      },
      {
        "icon": "ri-gift-line",
        "text": "Первый аудит бесплатно"
      }
    ],
    "form": {
      "fields": {
        "name": "Имя",
        "namePlaceholder": "Иван Иванов",
        "phone": "Телефон или Telegram",
        "phonePlaceholder": "+7 (___) ___-__-__",
        "message": "Что сейчас происходит в компании?",
        "messagePlaceholder": "Опишите ситуацию: заказы, сроки, узкие места..."
      },
      "submitLabel": "Получить экспресс-аудит",
      "submittingLabel": "Отправляем...",
      "errors": {
        "tooLong": "Сообщение не должно превышать 500 символов",
        "generic": "Не удалось отправить заявку. Попробуйте ещё раз.",
        "success": "Заявка отправлена! Свяжемся с вами в течение 15 минут"
      }
    }
  },
  "footer": {
    "copyright": "© 2026 LeanOps. Все права защищены."
  }
}
